import type {
  IExternalGroupedOrderPositionDTOData,
  IGroupedOrderPositionDTOData,
  IGroupedOrderProfitPlusPositionDTOData
} from '../../../dtos/ProdegaApiWebshop-api-typings-generated';
import { useCartSummary } from './useCartSummary';
import { useCartStateSelector } from './useCartStateSelector';

export function useCart() {
  const { orderId, positionCount, total, totalDiscount, amountNeededForMinimalOrder } = useCartSummary();
  const isCancellingCart = useCartStateSelector<boolean>(state => state?.value === 'CancellingOrder');
  const isSendingCart = useCartStateSelector<boolean>(state => state?.value === 'SendingOrder');
  const positions = useCartStateSelector<IGroupedOrderPositionDTOData[] | undefined>(state => {
    return state?.context?.currentOrder?.normalPositions?.concat(state?.context?.currentOrder?.profitPlusPositions);
  });
  const externalPositions = useCartStateSelector<IExternalGroupedOrderPositionDTOData[] | undefined>(
    state => state?.context?.currentOrder?.externalGroupedPositions
  );

  const profitPlusPositions = useCartStateSelector<IGroupedOrderProfitPlusPositionDTOData[] | undefined>(
    state => state?.context?.currentOrder?.profitPlusPositions
  );

  const normalPositions = useCartStateSelector<IGroupedOrderPositionDTOData[] | undefined>(
    state => state?.context?.currentOrder?.normalPositions
  );

  const isLoading = useCartStateSelector<boolean>(state => !state?.context.isInitialized);

  const noCart =
    useCartStateSelector<boolean>(state => !state?.context?.currentOrder) ||
    (positions?.length === 0 && externalPositions?.length === 0);

  const isOciOrder = useCartStateSelector<boolean>(state => state?.context?.currentOrder?.creationSystem === 'OCI');

  return {
    orderId,
    isCancellingCart,
    isSendingCart,
    positions,
    profitPlusPositions,
    normalPositions,
    externalPositions,
    isLoading,
    noCart,
    positionCount,
    total,
    totalDiscount,
    amountNeededForMinimalOrder,
    isOciOrder
  };
}
